<script>
import LayoutObserver from 'element-ui/packages/table/src/layout-observer';
import { mapStates } from 'element-ui/packages/table/src/store/helper';

export default {
    
}
</script>